import React from 'react'
import DeleteBtn from '../../../../assets/svg/delete.svg'

const QuestionBlock = ({ index, data, onUpdate, onDelete }) => {
  const handleTypeChange = (type) => {
    const reset = {
      type,
      text: '',
      options: type === 'multiple' ? ['', '', '', ''] : [],
      correctAnswers: [],
      shortAnswer: '',
    }
    onUpdate(data.id, reset)
  }

  const handleTextChange = (e) => {
    onUpdate(data.id, { text: e.target.value })
  }

  const handleOptionChange = (i, value) => {
    const newOptions = [...data.options]
    newOptions[i] = value
    onUpdate(data.id, { options: newOptions })
  }

  const toggleCorrectAnswer = (i) => {
    const updated = [i]
    onUpdate(data.id, { correctAnswers: updated })
  }

  const handleShortAnswer = (e) => {
    onUpdate(data.id, { shortAnswer: e.target.value })
  }
  return (
    <div className='flex flex-col gap-3'>
      <div className='flex justify-between items-center'>
        <p className='font-medium'>Question {index + 1}</p>
        <div
          onClick={() => onDelete(data.id)}
          className='text-red-500 cursor-pointer'
        >
          <img src={DeleteBtn} alt='Delete' />
        </div>
      </div>

      <div className='flex items-center gap-3'>
        {['multiple', 'truefalse', 'short'].map((type) => (
          <div
            key={type}
            onClick={() => handleTypeChange(type)}
            className={`px-3 py-1 border text-sm font-medium rounded cursor-pointer ${
              data.type === type ? 'bg-black text-white' : ''
            }`}
          >
            {type === 'multiple'
              ? 'Multiple choice'
              : type === 'truefalse'
              ? 'True / False'
              : 'Short Answer'}
          </div>
        ))}
      </div>

      {data.type && (
        <input
          type='text'
          placeholder='Type your question'
          value={data.text}
          onChange={handleTextChange}
          className='w-full border p-2 h-11 rounded-[10px] text-sm'
        />
      )}
      {(data.type === 'multiple' || data.type === 'truefalse') && (
        <p className='text-sm font-medium'>
          Use the checkbox to select the correct option
        </p>
      )}
      {data.type === 'multiple' && (
        <div className='grid grid-cols-2 mt-2 w-full gap-2 items-center justify-items-center'>
          {data.options.map((opt, i) => (
            <div key={i} className='flex items-center gap-2 w-full'>
              <input
                type='text'
                className='border p-2 h-11 rounded-[10px] text-sm'
                placeholder={`Option ${i + 1}`}
                value={opt}
                onChange={(e) => handleOptionChange(i, e.target.value)}
              />
              <input
                type='checkbox'
                className='accent-hr-primary-1'
                checked={data.correctAnswers.includes(i)}
                onChange={() => toggleCorrectAnswer(i)}
              />
            </div>
          ))}
        </div>
      )}

      {data.type === 'truefalse' && (
        <div className='space-y-2'>
          {['True', 'False'].map((label, i) => (
            <div key={i} className='flex items-center mt-2 space-x-2'>
              <p className='text-sm '>
                ({label === 'True' ? 'A' : 'B'}) {label}
              </p>
              <input
                type='checkbox'
                className='accent-hr-primary-1'
                checked={data.correctAnswers.includes(i)}
                onChange={() => toggleCorrectAnswer(i)}
              />
            </div>
          ))}
        </div>
      )}

      {data.type === 'short' && (
        <input
          type='text'
          placeholder='Type the correct answer'
          value={data.shortAnswer}
          onChange={handleShortAnswer}
          className='border w-full mt-2 p-2 h-11 rounded-[10px] text-sm'
        />
      )}
    </div>
  )
}

export default QuestionBlock
